import { render } from "./ClaimConfirmedNotice.vue?vue&type=template&id=be2cf786&scoped=true"
import script from "./ClaimConfirmedNotice.vue?vue&type=script&lang=js"
export * from "./ClaimConfirmedNotice.vue?vue&type=script&lang=js"

import "./ClaimConfirmedNotice.vue?vue&type=style&index=0&id=be2cf786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2cf786"]])

export default __exports__